<template>
	<section>
		<div v-if="foods.length >= 1">
			<div
				v-for="(item, index) in foods"
				:key="index"
				class="food-item"
			>
				<img
					crossorigin="anonymous"
					:src="`${server.url}/food/image/${item.food.photo}`"
					class="food-img"
				/>
				<div class="food-info">
					<p class="food-label" v-html="item.food.label"></p>
					<p
						class="food-desc"
						v-html="item.food.description"
					></p>
					<p class="food-date">
						<v-icon size="12" color="#9ca3af">mdi-calendar</v-icon>
						{{ item.food.createdAt }}
					</p>
				</div>
			</div>
		</div>
		<v-alert type="warning" dense text rounded="xl" v-else>
			Aucun repas attribué à ce client.
		</v-alert>
	</section>
</template>

<script>
import server from "@/config/address";
export default {
	props: ["foods"],
	data() {
		return { server };
	},
};
</script>

<style scoped>
.food-item {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 12px 0;
	border-bottom: 1px solid #f3f4f6;
	font-family: Montserrat, sans-serif;
}
.food-item:last-child {
	border-bottom: none;
}
.food-img {
	width: 52px;
	height: 52px;
	border-radius: 12px;
	object-fit: cover;
	flex-shrink: 0;
	background: #f3f4f6;
}
.food-info {
	flex: 1;
}
.food-label {
	font-size: 0.88rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 3px;
}
.food-desc {
	font-size: 0.75rem;
	color: #6b7280;
	margin: 0 0 4px;
}
.food-date {
	font-size: 0.68rem;
	color: #9ca3af;
	margin: 0;
	display: flex;
	align-items: center;
	gap: 4px;
}
</style>
